/**
 * Styled Components - Created by miguelcanobbio on 05/06/18.
 */
import styled from 'styled-components'
import Input from 'antd/lib/input'

interface InputProps {
  inputhWidth?: string
}

interface RowProps {
  marginBottom?: string
}

export const Container = styled.div`
  width: 100%;
  .lbls {
    font-weight: 500;
    font-size: 13px;
    font-family: Avenir;
    color: #ce4242;
  }
  ul {
    font-size: 12px;
  }
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${({ marginBottom }: RowProps) =>
    marginBottom ? marginBottom : '16px'};
`

export const Column = styled.div`
  width: ${({ inputhWidth }: InputProps) =>
    inputhWidth ? inputhWidth : '400px'};
`
export const InputTitleContainer = styled.div`
  display: flex;
`
export const Label = styled.div`
  height: 19px;
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
`

export const StyledInput = styled(Input)`
  height: 40px;
  width: 100%;
  border: 1px solid #bebebe;
  border-radius: 0;
  margin-top: 5px;
`
export const RequiredSpan = styled.span`
  color: #e61737;
  margin: 0 5px;
`

export const ErrorMsg = styled.div`
  height: 16px;
  color: #e61737;
  font-size: 12px;
  letter-spacing: 0.15px;
  line-height: 16px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ChangePasswordModal/styledComponents.tsx